module.exports = __webpack_public_path__ + "img/organization-group-hide.f6b8e4b7.svg";